import { DownloadSimple } from "@phosphor-icons/react";
import { api } from "../lib/api";
import { toast } from "sonner";

const download = async (saleId, paymentIndex, copy, ref) => {
  try {
    const { data } = await api.get(`/sales/${saleId}/tyro-receipts`, {
      params: { copy, fmt: "pdf", payment_index: paymentIndex ?? -1 },
      responseType: "blob",
    });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(data);
    a.download = `tyro-${copy}-copy-${ref || saleId}.pdf`;
    a.click();
  } catch (e) {
    let msg = "No Tyro receipt saved for this payment";
    try { msg = JSON.parse(await e.response.data.text()).detail || msg; } catch { /* keep default */ }
    toast.error(msg);
  }
};

/** Card + auth line and Customer / Merchant copy downloads for a Tyro tender. */
export default function TyroPaymentDetails({ meta, saleId, paymentIndex, testId }) {
  const last4 = (meta?.elided_pan || "").replace(/[^0-9]/g, "").slice(-4);
  const card = (meta?.card_type || "Card").toUpperCase();
  return (
    <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1" data-testid={testId}>
      <span className="text-[12px] font-semibold text-slate-700 font-mono" data-testid={`${testId}-card`}>
        {card}{last4 ? ` •••• ${last4}` : ""}
      </span>
      {meta?.authorisation_code && <span className="text-[11px] text-slate-500">Auth {meta.authorisation_code}</span>}
      {meta?.transaction_reference && <span className="text-[11px] text-slate-400">Ref {meta.transaction_reference}</span>}
      {saleId && ["customer", "merchant"].map((copy) => (
        <button
          key={copy}
          type="button"
          onClick={() => download(saleId, paymentIndex, copy, meta?.transaction_reference)}
          className="h-6 px-2 rounded-md border border-slate-200 text-[10px] font-semibold text-slate-600 hover:border-[#1E5FEB] hover:text-[#1E5FEB] flex items-center gap-1 transition-colors"
          data-testid={`${testId}-${copy}-copy`}
        >
          <DownloadSimple size={11} weight="bold" /> {copy === "customer" ? "Customer" : "Merchant"} copy
        </button>
      ))}
    </div>
  );
}
